import {
  LogRoot_getInstancecn9b38zgmoxq as LogRoot_getInstance,
  gczvdtmgupztxq as gc,
  printStackTrace214c8iyv3cpiv5 as printStackTrace2,
} from './debugger.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { clockMillis2lf7cl1xsmoff as clockMillis } from './clockMillis.mjs';
import { eachCount1imd75z0wkpbt as eachCount } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/GroupingJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { minOf33o15vox9quzb as minOf } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  Debugger_getInstancengm4b9abzu1y as Debugger_getInstance,
  Element$Debugger$_get_debugTarget_$ref_hg3jj310d00xurzosl8 as Element$Debugger$_get_debugTarget_$ref_hg3jj3,
  Element$Debugger$_set_debugTarget_$ref_rjtr1nub17bo9f1toi as Element$Debugger$_set_debugTarget_$ref_rjtr1n,
} from './views/Element.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_debugMode() {
  _init_properties_debugger_kt__md2uzj();
  return debugMode;
}
var debugMode;
var viewDebugTarget$delegate;
function get_leaks() {
  _init_properties_debugger_kt__md2uzj();
  return leaks;
}
var leaks;
function set_lastGc(_set____db54di) {
  _init_properties_debugger_kt__md2uzj();
  lastGc = _set____db54di;
}
function get_lastGc() {
  _init_properties_debugger_kt__md2uzj();
  return lastGc;
}
var lastGc;
function set_lastGcReport(_set____db54di) {
  _init_properties_debugger_kt__md2uzj();
  lastGcReport = _set____db54di;
}
function get_lastGcReport() {
  _init_properties_debugger_kt__md2uzj();
  return lastGcReport;
}
var lastGcReport;
function get_leakLog() {
  _init_properties_debugger_kt__md2uzj();
  return leakLog;
}
var leakLog;
function get_Throwable_report() {
  _init_properties_debugger_kt__md2uzj();
  return Throwable_report;
}
var Throwable_report;
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ {
      constructor() {
        Default_instance = this;
        this.$$delegate_0__1 = new (InterceptedLog())(LogRoot_getInstance());
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.interceptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      get_tag_18ivnz_k$() {
        return this.$$delegate_0__1.get_tag_18ivnz_k$();
      }
      tag_ioihsw_k$(tag) {
        return this.$$delegate_0__1.tag_ioihsw_k$(tag);
      }
      get_level_ium7h7_k$() {
        return this.$$delegate_0__1.get_level_ium7h7_k$();
      }
      withLevel_7ga69p_k$(level) {
        return this.$$delegate_0__1.withLevel_7ga69p_k$(level);
      }
      log_iyb52q_k$(entries) {
        this.$$delegate_0__1.log_iyb52q_k$(entries);
      }
      info_59mt0k_k$(entries) {
        this.$$delegate_0__1.info_59mt0k_k$(entries);
      }
      warn_e3mr9o_k$(entries) {
        this.$$delegate_0__1.warn_e3mr9o_k$(entries);
      }
      error_vwivre_k$(entries) {
        this.$$delegate_0__1.error_vwivre_k$(entries);
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  LogLevel_ERROR_instance = new (LogLevel())('ERROR', 0);
  LogLevel_WARN_instance = new (LogLevel())('WARN', 1);
  LogLevel_INFO_instance = new (LogLevel())('INFO', 2);
  LogLevel_LOG_instance = new (LogLevel())('LOG', 3);
}
var LogLevel_ERROR_instance;
var LogLevel_WARN_instance;
var LogLevel_INFO_instance;
var LogLevel_LOG_instance;
var LogLevelClass;
function LogLevel() {
  if (LogLevelClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'LogLevel');
    LogLevelClass = $;
  }
  return LogLevelClass;
}
function intercept($this, level, entries) {
  var _iterator__ex2g4s = Default_getInstance().interceptors_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var i = _iterator__ex2g4s.next_20eer_k$();
    i.intercept_69j91l_k$(level, $this.wraps_1.get_tag_18ivnz_k$(), entries);
  }
}
var InterceptedLogClass;
function InterceptedLog() {
  if (InterceptedLogClass === VOID) {
    class $ {
      constructor(wraps) {
        this.wraps_1 = wraps;
      }
      get_tag_18ivnz_k$() {
        return this.wraps_1.get_tag_18ivnz_k$();
      }
      tag_ioihsw_k$(tag) {
        return new (InterceptedLog())(this.wraps_1.tag_ioihsw_k$(tag));
      }
      get_level_ium7h7_k$() {
        return this.wraps_1.get_level_ium7h7_k$();
      }
      withLevel_7ga69p_k$(level) {
        return new (InterceptedLog())(this.wraps_1.withLevel_7ga69p_k$(level));
      }
      log_iyb52q_k$(entries) {
        if (this.wraps_1.get_level_ium7h7_k$().compareTo_30rs7w_k$(LogLevel_LOG_getInstance()) < 0)
          return Unit_instance;
        intercept(this, LogLevel_LOG_getInstance(), entries);
        this.wraps_1.log_iyb52q_k$(entries.slice());
      }
      info_59mt0k_k$(entries) {
        if (this.wraps_1.get_level_ium7h7_k$().compareTo_30rs7w_k$(LogLevel_INFO_getInstance()) < 0)
          return Unit_instance;
        intercept(this, LogLevel_INFO_getInstance(), entries);
        this.wraps_1.info_59mt0k_k$(entries.slice());
      }
      warn_e3mr9o_k$(entries) {
        if (this.wraps_1.get_level_ium7h7_k$().compareTo_30rs7w_k$(LogLevel_WARN_getInstance()) < 0)
          return Unit_instance;
        intercept(this, LogLevel_WARN_getInstance(), entries);
        this.wraps_1.warn_e3mr9o_k$(entries.slice());
      }
      error_vwivre_k$(entries) {
        intercept(this, LogLevel_ERROR_getInstance(), entries);
        this.wraps_1.error_vwivre_k$(entries.slice());
      }
    }
    initMetadataForClass($, 'InterceptedLog');
    InterceptedLogClass = $;
  }
  return InterceptedLogClass;
}
function report(_this__u8e3s4, context) {
  context = context === VOID ? '' : context;
  _init_properties_debugger_kt__md2uzj();
  return get_Throwable_report()(_this__u8e3s4, context);
}
function checkLeakAfterDelay(_this__u8e3s4, milliseconds) {
  _init_properties_debugger_kt__md2uzj();
  // Inline function 'com.lightningkite.kiteui.afterTimeout' call
  var tmp = window;
  var handle = tmp.setTimeout(() => {
    gcIfNotVeryRecent();
    if (_this__u8e3s4.get_26vq_k$() == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      get_leaks().add_utx5q5_k$(_this__u8e3s4);
      recheckLeakAfterDelay(_this__u8e3s4, milliseconds);
    }
    return Unit_instance;
  }, convertToInt(milliseconds));
}
function gcIfNotVeryRecent() {
  _init_properties_debugger_kt__md2uzj();
  if (clockMillis() - get_lastGc() > 100.0) {
    gc();
    set_lastGc(clockMillis());
  }
  if (clockMillis() - get_lastGcReport() > 1000.0) {
    set_lastGcReport(clockMillis());
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!get_leaks().isEmpty_y1axqb_k$()) {
      get_leakLog().log_iyb52q_k$(['WARNING: ' + get_leaks().get_size_woubt6_k$() + ' leaks...']);
      // Inline function 'kotlin.collections.groupingBy' call
      var this_0 = get_leaks();
      var tmp$ret$1 = new (gcIfNotVeryRecent$$inlined$groupingBy$1())(this_0);
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = eachCount(tmp$ret$1).get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        get_leakLog().log_iyb52q_k$(['  Leaked ' + element.get_value_j01efc_k$() + ' of ' + toString(element.get_key_18j28a_k$())]);
      }
    }
  }
}
function recheckLeakAfterDelay(_this__u8e3s4, milliseconds) {
  _init_properties_debugger_kt__md2uzj();
  // Inline function 'com.lightningkite.kiteui.afterTimeout' call
  var tmp = window;
  var handle = tmp.setTimeout(() => {
    gcIfNotVeryRecent();
    if (_this__u8e3s4.get_26vq_k$() == null) {
      get_leaks().remove_cedx0m_k$(_this__u8e3s4);
    } else {
      recheckLeakAfterDelay(_this__u8e3s4, milliseconds);
    }
    return Unit_instance;
  }, convertToInt(milliseconds));
}
var GCInfoClass;
function GCInfo() {
  if (GCInfoClass === VOID) {
    class $ {
      constructor(usage) {
        this.usage_1 = usage;
      }
      toString() {
        return 'GCInfo(usage=' + this.usage_1.toString() + ')';
      }
      hashCode() {
        return getBigIntHashCode(this.usage_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GCInfo()))
          return false;
        if (!(this.usage_1 === other.usage_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GCInfo');
    GCInfoClass = $;
  }
  return GCInfoClass;
}
function Log(tag, level) {
  level = level === VOID ? LogLevel_LOG_getInstance() : level;
  _init_properties_debugger_kt__md2uzj();
  return Default_getInstance().tag_ioihsw_k$(tag).withLevel_7ga69p_k$(level);
}
function infoOrAbove(_this__u8e3s4) {
  _init_properties_debugger_kt__md2uzj();
  return _this__u8e3s4.withLevel_7ga69p_k$(minOf(_this__u8e3s4.get_level_ium7h7_k$(), LogLevel_INFO_getInstance()));
}
function Throwable_report$lambda(e, _unused_var__etf5q3) {
  _init_properties_debugger_kt__md2uzj();
  printStackTrace2(e);
  return Unit_instance;
}
var gcIfNotVeryRecent$$inlined$groupingBy$1Class;
function gcIfNotVeryRecent$$inlined$groupingBy$1() {
  if (gcIfNotVeryRecent$$inlined$groupingBy$1Class === VOID) {
    class $ {
      constructor($this) {
        this.$this_1 = $this;
      }
      sourceIterator_2zqxcn_k$() {
        return this.$this_1.iterator_jk1svi_k$();
      }
      keyOf_qdhuon_k$(element) {
        var tmp0_safe_receiver = element.get_26vq_k$();
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = getKClassFromExpression(tmp0_safe_receiver);
        }
        return tmp;
      }
      keyOf_d1fr09_k$(element) {
        return this.keyOf_qdhuon_k$(element);
      }
    }
    initMetadataForClass($);
    gcIfNotVeryRecent$$inlined$groupingBy$1Class = $;
  }
  return gcIfNotVeryRecent$$inlined$groupingBy$1Class;
}
function LogLevel_ERROR_getInstance() {
  static_init();
  return LogLevel_ERROR_instance;
}
function LogLevel_WARN_getInstance() {
  static_init();
  return LogLevel_WARN_instance;
}
function LogLevel_INFO_getInstance() {
  static_init();
  return LogLevel_INFO_instance;
}
function LogLevel_LOG_getInstance() {
  static_init();
  return LogLevel_LOG_instance;
}
var properties_initialized_debugger_kt_wmk7x9;
function _init_properties_debugger_kt__md2uzj() {
  if (!properties_initialized_debugger_kt_wmk7x9) {
    properties_initialized_debugger_kt_wmk7x9 = true;
    debugMode = false;
    var tmp0 = Debugger_getInstance();
    var tmp = KMutableProperty0();
    var tmp_0 = Element$Debugger$_get_debugTarget_$ref_hg3jj3(tmp0);
    viewDebugTarget$delegate = getPropertyCallableRef('debugTarget', 0, tmp, tmp_0, Element$Debugger$_set_debugTarget_$ref_rjtr1n(tmp0));
    leaks = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    lastGc = clockMillis();
    lastGcReport = clockMillis();
    leakLog = LogRoot_getInstance().tag_ioihsw_k$('ElementLeaks');
    Throwable_report = Throwable_report$lambda;
  }
}
//region block: exports
export {
  GCInfo as GCInfoouume21kiwko,
  Log as Log1znm0y8m419dj,
  checkLeakAfterDelay as checkLeakAfterDelayr9e6vxihbhwn,
  get_debugMode as get_debugMode2ku08uo1anfv,
  infoOrAbove as infoOrAbove10o4ftgq7f7ui,
  report as report1vfr9zf0i9d9p,
  LogLevel_INFO_getInstance as LogLevel_INFO_getInstanceggyvesvkxzn4,
  LogLevel_LOG_getInstance as LogLevel_LOG_getInstance27xt7eijwohj,
  LogLevel_WARN_getInstance as LogLevel_WARN_getInstance3t76hodk0ofiq,
  Default_getInstance as Default_getInstance27jodt8hd1bac,
};
//endregion

//# sourceMappingURL=debugger.mjs.map
